import React, { useState } from "react";

const Policies = ({ policies, aboutUs, houseRules }) => {
  const [step, setStep] = useState(0);
  const active =
    "w-1/6 rounded-lg bg-black text-white text-center opacity-90 hover:cursor-pointer py-2 mx-16";
  const unactive =
    "w-1/6 rounded-lg bg-black text-white text-center opacity-50 hover:cursor-pointer py-2 mx-16";

  // //console.log(policies);

  return (
    <div className="flex justify-center font-sans mt-2">
      <div className="p-4 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <div className="flex flex-row justify-center w-full">
          <div
            className={step == 0 ? active : unactive}
            onClick={() => {
              setStep(0);
            }}
          >
            Reviews
          </div>
          <div
            className={step == 1 ? active : unactive}
            onClick={() => {
              setStep(1);
            }}
          >
            House Rules
          </div>
          <div
            className={step == 2 ? active : unactive}
            onClick={() => {
              setStep(2);
            }}
          >
            Policies
          </div>
        </div>
        {step == 0 && (
          <div className="mb-4 mt-10 ml-4">
            <div className="mb-4 text-[15px]">{aboutUs}</div>
            <div className="flex justify-center">
              <button className="bg-none hover:scale-[1.05] text-black py-1 px-2 text-[13px] font-semibold rounded-full border-2 border-black transition-all">
                Read more
              </button>
            </div>
          </div>
        )}
        {step == 1 && (
          <div className="mb-4 mt-10 ml-4">
            <ul className="mb-4 text-[15px]">
              {houseRules.map((item, i) => {
                return <li className="list-disc">{item}</li>;
              })}
            </ul>
            <div className="flex justify-center">
              <button className="bg-none hover:scale-[1.05] text-black py-1 px-2 text-[13px] font-semibold rounded-full border-2 border-black transition-all">
                Read more
              </button>
            </div>
          </div>
        )}
        {step == 2 && (
          <div className="mb-4 mt-10 ml-4">
            <ul className="mb-4 text-[15px]">
              {policies.map((item, i) => {
                return <li className="list-disc">{item}</li>;
              })}
            </ul>
            <div className="flex justify-center">
              <button className="bg-none hover:scale-[1.05] text-black py-1 px-2 text-[13px] font-semibold rounded-full border-2 border-black transition-all">
                Read more
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Policies;
